module.exports = __webpack_public_path__ + "img/cert-auth.021d2ff2.svg";